import React, { useEffect, useState } from 'react'
import { axiosInstance } from '../../Helpers/axiosInstance'

export const store = React.createContext()

export default function State({children}) {

  const [baseList, setBaseList]= useState([])
  const [unitList, setUnitList] = useState([])
  const fetchUnits = async() => {
    try{
    const response = await axiosInstance.get('admin/milunits')
    setUnitList(response.data.data)
    }
    catch(error){
      console.error("Error fetching units:", error);
    }
  }
  const fetchBases = async (unit_number) => {
    if (!unit_number) return; 
    try {
      
      const unitNumber = unit_number.startsWith("#") ? unit_number.replace('#', 't') : unit_number
      const response = await axiosInstance.get(`admin/bases-from-unit/${unitNumber}`);
      setBaseList(response.data);
    } catch (error) {
      console.error("Error fetching bases:", error);
      setBaseList([]);
    }
  };

  const mainState = {
    baseList,
    setBaseList,
    unitList,
    setUnitList,
    fetchUnits,
    fetchBases
  }

  return (
    <store.Provider value={mainState}>
        {children}
    </store.Provider>
  )
}